export default __webpack_public_path__ + "assets/c8989ed2e807fbfeb1c3fa7fc6af4d8a.svg";